// Taken from https://github.com/wix-private/media-manager-js-sdk/blob/master/src/dto/media-type.js
export enum MediaType {
  AUDIO = 'music',
  VIDEO = 'video',
  IMAGE = 'picture',
  DOCUMENT = 'document',
}

// Taken from https://github.com/wix-private/media-manager-js-sdk/blob/master/src/dto/upload/upload-request.js#L34
export type MediaPrivacy = 'public' | 'private';

export const MEDIA_SERVICES_URL = '/_serverless/ricos-media-services';
